<template>
  <div
    class="group aspect-h-7 aspect-w-10 relative block w-full overflow-hidden rounded-lg border border-2 border-transparent bg-gray-100 hover:border-primary"
    :class="{'border-primary opacity-75': isSelected}">
    <blur-hash
      v-if="file?.mime_type.includes('image/')"
      :hash="file.custom_properties?.blur_hash"
      :src="file.small ?? file.original_url"
      :alt="file.custom_properties?.description ?? file.name"
      class="aspect-h-7 aspect-w-10" />
    <div
      v-else-if="file?.mime_type.includes('video/')"
      class="pointer-events-none text-indigo-700 group-hover:opacity-75">
      <div class="relative flex h-full flex-col items-center justify-center text-gray-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1"
          stroke="currentColor"
          class="absolute size-24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
        </svg>

        <video
          :src="file.original_url"
          class="h-full object-cover" />
      </div>
    </div>
    <div
      v-else
      class="pointer-events-none flex flex-col items-center justify-center bg-indigo-100 object-cover text-indigo-700 group-hover:opacity-75">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-12">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
      </svg>
      <span>Unknown media type</span>
    </div>
    <button
      type="button"
      class="absolute inset-0 focus:outline-none">
      <span class="sr-only">Select {{ file?.name }}</span>
    </button>
    <div
      v-if="isSelected"
      class="absolute inset-0">
      <svg
        class="absolute right-1 top-1 size-5 text-primary"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
  </div>
  <p class="pointer-events-none mt-1.5 block truncate text-xs font-medium text-font-dark">
    {{ file.name }}
  </p>
  <p
    title="alt description"
    class=" mt-0.5 block truncate text-xs italic text-gray-500">
    {{ file?.custom_properties?.alt_description }}
  </p>
  <div class="mt-0.5 flex justify-between text-xs font-medium text-font-light">
    <p class="pointer-events-none block">
      <formatted-size :size="file.size" />
    </p>
    <p
      v-if="file?.custom_properties.credit"
      class="pointer-events-none block italic">
      Credit: {{ file?.custom_properties?.credit }}
    </p>
  </div>
</template>

<script setup>

import FormattedSize from '@/ComponentsDeprecated/FormattedSize.vue';
import BlurHash from '@/ComponentsDeprecated/BlurHash.vue';

const props = defineProps({
  file: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});
</script>
